import { inject, Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { catchError, map, of, switchMap, tap, withLatestFrom } from "rxjs";
import { BreecePermissionApiService } from "../../services/api-services/permissions/breece-permissions.api-service";
import { GeneralStateAction } from "../pageState/page-state.actions";
import {
  selectRedirectUrl
} from "../pageState/page-state.selectors";
import { SecurityStateAction } from "./security-state.actions";

@Injectable()
export class SecurityStateEffects {

  actions$: Actions = inject(Actions);
  store: Store = inject(Store);
  router: Router = inject(Router);
  permissionApiService: BreecePermissionApiService = inject(BreecePermissionApiService);



  getInstallationPermissions$ = createEffect(() =>
    this.actions$.pipe(ofType(SecurityStateAction.getInstallationPermissions),
      switchMap((action) => {
        return this.permissionApiService.getInstallationPermissions()
          .pipe(
            map((permissions) =>
              SecurityStateAction.getInstallationPermissionsSuccess({ installationPermissions: permissions.find(x => x.refCode != null) ?? null, systemPermissions: permissions.find(x => x.refCode == null) ?? null })
            ),
            catchError((error) => {
              return of(SecurityStateAction.getInstallationPermissionsFailed({ error: error }))
            }
            )
          )
      }
      )
    )
  );


  getSystemPermissions$ = createEffect(() =>
    this.actions$.pipe(ofType(SecurityStateAction.getSystemPermissions),
      switchMap(() => {
        return this.permissionApiService.getSystemPermissions()
          .pipe(
            map((permissions) =>
              SecurityStateAction.getSystemPermissionsSuccess({ systemPermissions: permissions.find(x => x.refCode == null) ?? null })
            ),
            catchError((error) => {
              return of(SecurityStateAction.getInstallationPermissionsFailed({ error: error }))
            })
          )
      })
    )
  );


  redirectToUrl$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(SecurityStateAction.getInstallationPermissionsSuccess),
      withLatestFrom(this.store.select(selectRedirectUrl)),
      tap(([action, redirectUrl]) => {
        if (redirectUrl != null) {
          this.store.dispatch(GeneralStateAction.setRedirectUrlState({ redirectUrl: null }));
          this.router.navigate([redirectUrl])
        }
      })
    );
  }, { dispatch: false }
  );
}
